import { useMutation } from '@tanstack/react-query';

import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';

export type AdminEmailCheckResult = {
  exists: boolean;
};

/**
 * Checks whether a person with the given email exists.
 * Used by the organization creation flow to validate the admin email before submitting.
 *
 * Errors are intentionally not surfaced via a toast here (plain {@link useMutation} instead of
 * {@link useApiMutation}); the caller decides how to react, and schema validation still applies on
 * submit.
 */
export const useCheckAdminEmail = () => {
  const api = useGrapevineOrganizationApi();

  return useMutation<AdminEmailCheckResult, Error, string>({
    mutationFn: async (adminEmail: string) => {
      const result = await api.checkAdminEmail({
        clientOrganizationAdminEmailCheckRequest: { adminEmail }
      });
      return {
        exists: result._exists ?? false
      };
    }
  });
};
